/**
 * 定制化获取自定义表单数据接口封装
 */
import { dataList } from "@/api/formList";
import { page, details } from "@/api/formSet";

// 图片类型格式
export const imgType = [
  "heic",
  "bmp",
  "jpg",
  "jpeg",
  "png",
  "tif",
  "gif",
  "pcx",
  "tga",
  "exif",
  "fpx",
  "svg",
  "psd",
  "cdr",
  "pcd",
  "dxf",
  "ufo",
  "eps",
  "ai",
  "raw",
  "WMF",
  "webp",
  "avif",
  "apng",
];

// 深拷贝
export function deepClone(data) {
  return JSON.parse(JSON.stringify(data));
}

// 生成uuid
export function uuidv4() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    let r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

// 冒泡排序
export function bubbleSort(arr, key, sort) {
  let len = arr.length;
  // 升序
  if (sort == "asc") {
    for (let i = 0; i < len; i++) {
      for (let j = 0; j < len - 1 - i; j++) {
        if (parseInt(arr[j][key]) > parseInt(arr[j + 1][key])) {
          //相邻元素两两对比
          let temp = arr[j + 1]; //元素交换
          arr[j + 1] = arr[j];
          arr[j] = temp;
        }
      }
    }
  } else {
    for (let i = 0; i < len; i++) {
      for (let j = 0; j < len - 1 - i; j++) {
        if (parseInt(arr[j][key]) < parseInt(arr[j + 1][key])) {
          //相邻元素两两对比
          let temp = arr[j + 1]; //元素交换
          arr[j + 1] = arr[j];
          arr[j] = temp;
        }
      }
    }
  }
  return arr;
}

// 保存每一个获取到的tableID以及tableName的配置信息，刷新之后自动清除
let tableConfig = {};
// 获取自定义表单数据
export function getTableData(params, tableConfig) {
  let newParams = {
    chargeList: false,
    currentNo: params.currentNo || 1,
    dataIdList: params.dataIdList || [],
    findType: params.findType || 3,
    pageSize: params.pageSize || 10,
    queryConditions: params.queryConditions || [],
    sortConfig: params.sortConfig || {},
    tableId: tableConfig.id,
    userId: params.userId || 1,
  };
  return dataList(newParams).then((item) => {
    if (item) {
      let params = {
        tableData: item.data,
        tableConfig,
      };
      return params;
    } else {
      return false;
    }
  });
}
// 根据tableID以及tableName 获取自定义表单数据
export function getDataList(params) {
  if (tableConfig[params.tableName] || tableConfig[params.tableId]) {
    // 直接获取表格数据，已存在tableId
    return getTableData(
      params,
      tableConfig[params.tableName] || tableConfig[params.tableId]
    ).then((item) => {
      return item;
    });
  } else {
    let fun = "";
    let newParams = {};
    if (params.tableId) {
      fun = details;
      newParams = {
        id: params.tableId,
      };
    } else {
      fun = page;
      newParams = {
        tableName: params.tableName,
        currentNo: params.currentNo,
        pageSize: params.pageSize,
      };
    }
    // 先获取tableId，再通过ID获取表格数据
    return fun(newParams).then((res) => {
      if (res) {
        let newData = "";
        if (!params.tableId) {
          newData = filterFn(res.data.dataList, "tableName", params.tableName);
        } else {
          newData = res.data;
        }
        if (newData) {
          tableConfig[newData.tableName] = newData;
          tableConfig[newData.id] = newData;
          return getTableData(params, tableConfig[newData.tableName]).then(
            (item) => {
              return item;
            }
          );
        } else {
          return false;
        }
      } else {
        return false;
      }
    });
  }
}
// 根据tableName获取tableId获取表单详细配置信息
export function getTableConfig(params) {
  if (tableConfig[params.tableName] || tableConfig[params.tableId]) {
    let fun = new Promise((resolve) => {
      resolve(tableConfig[params.tableName] || tableConfig[params.tableId]);
    });
    // 直接获取表格数据，已存在tableId
    return fun.then((res) => {
      return res;
    });
  } else {
    let fun = "";
    let newParams = {};
    if (params.tableId) {
      fun = details;
      newParams = {
        id: params.tableId,
      };
    } else {
      fun = page;
      newParams = {
        tableName: params.tableName,
        currentNo: 1,
        pageSize: 10,
      };
    }
    // 先获取tableId，再通过ID获取表格数据
    return fun(newParams).then((res) => {
      if (res) {
        let newData = "";
        if (!params.tableId) {
          newData = filterFn(res.data.dataList, "tableName", params.tableName);
        } else {
          newData = res.data;
        }
        if (newData) {
          tableConfig[newData.tableName] = newData;
          tableConfig[newData.id] = newData;
          return newData;
        } else {
          return false;
        }
      } else {
        return false;
      }
    });
  }
}

// 筛选方法
function filterFn(data, name, value) {
  let arr = [];
  arr = data.filter((res) => {
    return res[name] == value;
  });
  if (arr.length > 0) {
    return arr[0];
  } else {
    return false;
  }
}

// 对消息特别处理
export function opMessage(value) {
  if ($isJSON(value)) {
    return JSON.parse(value).msg;
  } else {
    return value;
  }
}

// 判断是否是JSON
function $isJSON(str) {
  if (typeof str == "string") {
    try {
      var obj = JSON.parse(str);
      if (typeof obj == "object" && obj) {
        return true;
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
  } else {
    return false;
  }
}

// 树形结构数据查找某一节点所有父节点数据 具体用于面包屑的展示
export function treeFindPath(tree, func, path = []) {
  if (!tree) return [];
  for (const data of tree) {
    path.push(data);
    if (func(data)) return path;
    if (data.permissionList) {
      const findChildren = treeFindPath(data.permissionList, func, path);
      if (findChildren.length) return findChildren;
    }
    if (data.children) {
      const findChildren = treeFindPath(data.children, func, path);
      if (findChildren.length) return findChildren;
    }
    path.pop();
  }
  return [];
}

// 重写数据结构-roleList
export function reSetTreeData(tree) {
  let sourceTree = JSON.parse(JSON.stringify(tree));
  let newTree = [];
  sourceTree.forEach((item) => {
    if (!item.menuName) {
      item.menuName = item.name || item.buttonName;
    }
    if (item.children && item.children.length > 0) {
      let data = reSetTreeData(item.children);
      if (item.permissionList && item.permissionList.length > 0) {
        item.permissionList = [...data, ...item.permissionList];
      } else {
        item.permissionList = [...data];
      }
    }
    if (item.permissionList.length > 0) {
      item.permissionList.map((per) => {
        if (!per.tableId) {
          per.nodeId = `menu${per.id}`;
          per.menuName = per.menuName || per.name;
        } else {
          per.nodeId = per.id;
        }
        if (per.buttonList?.length > 0) {
          per.permissionList = per.buttonList.map((btn) => {
            return {
              nodeId: `${per.tableId}-${btn.id}`,
              menuName: btn.buttonName,
              ...btn,
            };
          });
        }
      });
    }
    newTree.push(item);
  });
  return newTree;
}

// 重写数据结构-HeaderNav
export function reSetTreeData2(tree) {
  let sourceTree = JSON.parse(JSON.stringify(tree));
  sourceTree.forEach((item) => {
    if (!item.menuName) {
      item.menuName = item.name;
    }
    if (!item.permissionList) {
      item.permissionList = [];
    }
    if (item.children && item.children.length > 0) {
      let tmp = getPermission(item.children, item.permissionList);
      item.permissionList = tmp;
    }
  });
  return sourceTree;
}

function getPermission(arr, tmp) {
  let newTmp = JSON.parse(JSON.stringify(tmp));
  arr.forEach((item) => {
    if (item.permissionList && item.permissionList.length > 0) {
      newTmp = [...newTmp, ...item.permissionList];
    }
    if (item.children && item.children.length > 0) {
      newTmp = getPermission(item.children, newTmp);
    }
  });
  return newTmp;
}
